import React from "react";
import Navbar from '../../components/Navbar';
import DashboardNav from "../../components/DashboardSection/DashboardNav";
import DashboardContent from "../../components/DashboardSection/DashboardContent";
import "../../styles/DashboardStyles/Dashboard.css";


export default function Dashboard() {
    return (
        <div>
            <Navbar />
            <div className="dashboardContainer">
                <DashboardNav />
                <DashboardContent />
            </div>
        </div>
    );
}
